package com.ucasoft.komm.website.pages.home

import mui.material.Box
import react.FC

val HomePage = FC {
    Box {
        Hero {}
        Features {}
        Targets {}
    }
}